import React, { useRef, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery';
import * as R from 'ramda';
import parsePhoneNumber from 'libphonenumber-js';

import {CreateUsersByPartnerId, AddUserAddress, AddReferentToUserId, SendUserActivationEmailByPartnerId} from '../../../actions/partner/partner';
import {ToasterConfigurations} from '../../../constants/toasterText/configurations';

import { DossierTypeSection } from './dossierTypeSection';
import { ReferentSection } from './referentSection';
import { PersonalInformationSection } from './personalInformationSection';
import {AjouterDossierHeader} from './header';
import {PaymentModeSection} from './paymentModeSection';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { LettersSendingModeSection } from './lettersSendingModeSection';

export const AjouterDossier = ({partner, etablissement}) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const creationForm = useRef(null);

	let defaultSteps = [false, false];

	const [isLoading, setIsLoading] = useState(false);
	const [steps, setSteps] = useState(defaultSteps);
	const [skipReferentSection, setSkipReferentSection] = useState(false);
	
	const dossierTypeOptions = {anticipa:'Anticipa', facilita: 'Facilita', serenita: 'Serenita'};


	function scrollToFirstInvalid() {
        const nodes = window.document.querySelectorAll('.was-validated .form-control:invalid');
        if (!R.isNil(nodes) && nodes.length > 0) {
            // let nodesNotHidden = nodes.find(n => !n.classList.includes('hidden'));
            nodes[0].scrollIntoView({ behavior: 'smooth' });
        }
	}
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	

	const [account, setAccount] = useState({
		type: dossierTypeOptions.facilita,
		gender: undefined,
		firstName: '', 
		lastName:'', 
		birthDate: undefined,
		deathDate: undefined,
		email: '',
		phoneNumber: '',
		countryCode: '33',
		phoneCountry: 'FR',
		billedByPartner: true,
		partnerId: partner?.id,
		etablissementId: etablissement?.id,
		hasDocumentSending: etablissement?.partnerDocumentSendingType === "AlwaysSendByPost" ? true : etablissement?.partnerDocumentSendingType === "NeverSendByPost" ? false : undefined,
		address: {
			addressContract:'1',
			addressType:'1',
			addressLine1:'',
			addressLine2:'',
			postalCode:'',
			city:'',
			country:'FR',
		},
		referent:{
			gender: undefined,
			firstName: '', 
			lastName:'',
			birthDate: undefined,
			email: '',
			phoneNumber: '',
			countryCode: '33',
			phoneCountry: 'FR',
			userId: undefined,
			address: {
				addressContract:'1',
				addressType:'1',
				addressLine1:'',
				addressLine2:'',
				postalCode:'',
				city:'',
				country:'FR',
			},
		}
	});

	useEffect(() => {
		if(!R.isNil(creationForm.current)){
			creationForm.current.classList.remove('was-validated');
		}

		
		let newSteps = [...steps];
		
		let isPersonalInformationSectionValid = true;
		const personalInformationSectionInputs = $("#PersonalInformationSection :input");
		personalInformationSectionInputs.map((index, input) => {
			if(!input.checkValidity())
			isPersonalInformationSectionValid = false;
		});
		if(isPersonalInformationSectionValid && personalInformationSectionInputs.length > 0){
			newSteps = newSteps.map((value, index) => index === 0 ? true : value);
		}else{
			newSteps = newSteps.map((value, index) => index === 0 ? false : value);
		}

		if(skipReferentSection){
			newSteps = newSteps.map((value, index) => index === 1 ? true : value);
		}else{
			let isReferentSectionValid = true;
			const referentSectionInputs = $("#ReferentSection :input");
			referentSectionInputs.map((index, input) => {
				if(!input.checkValidity())
				isReferentSectionValid = false;
			});
			if(isReferentSectionValid && referentSectionInputs.length > 0){
				newSteps = newSteps.map((value, index) => index === 1 ? true : value);
			}else{
				newSteps = newSteps.map((value, index) => index === 1 ? false : value);
			}
		}
		setSteps(newSteps);
			
	}, [account, skipReferentSection]);

	useEffect(() => {
		if(steps.every(step => step === true) && skipReferentSection){
			$('#accordionRefDossier').collapse('hide');
		}
		if(steps.length === 4 && steps.slice(0,3).every(step => step === true) && steps[3] === false){
			document.getElementById("next-button").click();
		}
	}, [steps])

	useEffect(() => {
		setSkipReferentSection(false);
	}, [account.referent])

	

	if(R.isNil(etablissement) || R.isNil(partner))
		return '';

	return (
		<article className="view-calc my-auto">
			<div className="auto-view my-auto">
				<div className="container-fluid h-100">
					<div className="card shadow h-inherit">
						<div className="card-header pb-0">
							<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Partner Dossier</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="ajouterDossierLabel">ajouter un nouveau dossier</div>
									{/* <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button> */}
								</div>
							</div>
						</div>
						<div className="card-body scroll-default">
							<AjouterDossierHeader account={account} setAccount={setAccount} steps={steps} dossierTypeOptions={dossierTypeOptions} etablissement={etablissement} />
							<hr />
							<form className="accordion mt-sm" id="accordionCreateDossier" ref={creationForm} noValidate>
								{/* to lock and accordion add to the card-header the classes: 'o-60 no-event' once is done add to title h3 the class: 'text-success'*/}
								{/* <DossierTypeSection account={account} setAccount={setAccount} dossierTypeOptions={dossierTypeOptions} steps={steps} setSteps={setSteps} etablissement={etablissement} /> */}
								<PersonalInformationSection account={account} setAccount={setAccount} dossierTypeOptions={dossierTypeOptions} steps={steps} />
								<ReferentSection referent={account.referent} setReferent={(referent) => setAccount({...account, referent:referent})} steps={steps} skipReferentSection={skipReferentSection} setSkipReferentSection={setSkipReferentSection} dossierTypeOptions={dossierTypeOptions} accountType={account.type} />								
							</form>

						</div>
						<div className="card-footer flex-row align-items-center">
							<button onClick={() => history.goBack()} className="btn btn-faded">Fermer</button>
							{
								steps.some(step => step === false) ?
									<button type="button" className="btn btn-info ml-2" id="next-button" onClick={(e) => {
										for(let i = 0; i < steps.length; i++){
											if(i == 0 && !steps[i]){
												if($('#accordionUserDossier').hasClass('show')){
													creationForm.current.checkValidity();
													creationForm.current.classList.add('was-validated');
												}
												$('#accordionUserDossier').collapse('show');
												return;
											}
											if(i == 1 && !steps[i]){
												if($('#accordionRefDossier').hasClass('show')){
													creationForm.current.checkValidity();
													creationForm.current.classList.add('was-validated');
												}
												$('#accordionRefDossier').collapse('show');
												return;
											}
										}
										
										
								}} >Suivant</button>
								:
								isLoading ? 
									<button type="button" className="btn btn-info ml-2 loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer</button>
								:
									<button type="button" className="btn btn-info ml-2" id="save-button" onClick={(e) => {
										e.preventDefault();
										let internationalPhoneNumber = null;
										
										let internationalPhoneNumberReferent = null;
										if(!R.isNil(account.referent.phoneNumber) && !R.isEmpty(account.referent.phoneNumber)){
											internationalPhoneNumberReferent = parsePhoneNumber(account.referent.phoneNumber, account.referent.phoneCountry);
											if(R.isNil(internationalPhoneNumberReferent) || !internationalPhoneNumberReferent.isValid()){
												document.getElementById("TelephoneReferentInput").setCustomValidity("Le numéro de téléphone n'est pas valide.")
											}	
										}
																		
										if(creationForm.current.checkValidity()){
											setIsLoading(true);
											dispatch(CreateUsersByPartnerId(partner.id, {...account, phoneNumber: internationalPhoneNumber?.number, referent:undefined, address:undefined, isEnabled: true, createdByRepresentative: account.type !== dossierTypeOptions.anticipa, isSerenita: account.type === dossierTypeOptions.serenita}))
											.then((user) => {
												const adduserAddressPromise = AddUserAddress(user.id, {...account.address});
												let addReferentPromise = null;
												if(steps[1] && !skipReferentSection){
													addReferentPromise = AddReferentToUserId(user.id, {...account.referent, phoneNumber: internationalPhoneNumberReferent?.number, address: undefined, isMainRepresentative: true, addresses: [account.referent.address]});
												}
												Promise.all([adduserAddressPromise, addReferentPromise]).then((results) => {
													setIsLoading(false);
													history.push("/funecap/dossiers");	
												})
												.catch((error) => {
													setIsLoading(false);
												});
												
											}).catch((error) => {
												setIsLoading(false);
												if(error.response.status === 409){
													const fields = Object.getOwnPropertyNames(error.response.data.errors);
													if(fields.indexOf("PhoneNumber") > -1){
														document.getElementById("phoneNumber").setCustomValidity("Ce numéro de téléphone est déjà utilisé");
														$('#accordionUserDossier').collapse('show');
														toast.error("Ce numéro de téléphone est déjà utilisé", ToasterConfigurations)
													}
													if(fields.indexOf("Email") > -1){
														document.getElementById("email").setCustomValidity("Cette adresse e-mail est déjà utilisée.");
														$('#accordionUserDossier').collapse('show');
														toast.error("Cette adresse e-mail est déjà utilisée.", ToasterConfigurations)
													}
												}
											});
										}
										creationForm.current.classList.add('was-validated');
										scrollToFirstInvalid();
									}}>Enregistrer</button>
							}
							<h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
						</div>
					</div>
				</div>
			</div>
		</article>
	)
}